import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {requestCustomFields} from "../../../redux/Actions/customFields.actions";
import {
  getCustomFieldsList,
  getCustomFieldsTotalCount,
  getCustomFieldsPaginationUrls,
} from "../../../redux/Selectors/customFields.selector";

export const useCustomFieldsTableData = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const customFieldsList = useSelector(getCustomFieldsList);
  const customFieldsTotalCount = useSelector(getCustomFieldsTotalCount);
  const customFieldsUrls = useSelector(getCustomFieldsPaginationUrls);

  useEffect(() => {
    dispatch(requestCustomFields());
  }, [dispatch]);

  const handlePageChange = (page) => {
    const url =
      currentPage < page ? customFieldsUrls?.nextUrl : customFieldsUrls?.prevUrl;
    dispatch(requestCustomFields(url));
    setCurrentPage(page);
  };

  const paginationConfig = {
    currentPage,
    onPageChange: handlePageChange,
  };

  return {paginationConfig, customFieldsList, customFieldsTotalCount};
};
